import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      padding: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
      '& > div:last-child': {
        marginTop: theme.spacing(3)
      }
    },
    title: {
      marginBottom: theme.spacing(1)
    },
    roleContainer: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    text: {
      fontWeight: 400
    }
  };
});

export interface OrganizationListItem {
  name: string;
  roles?: Array<string>;
}
interface UserOrganizationRoleInformationProps {
  organizations: Array<OrganizationListItem>;
}

const UserOrganizationRoleInformation: React.FC<UserOrganizationRoleInformationProps> = ({
  organizations
}) => {
  const classes = useStyles();

  return (
    <Paper className={classes.root} elevation={3}>
      <Typography variant="h2" className={classes.title}>
        Organizations & Roles
      </Typography>
      <List>
        {organizations.map(({ name, roles }) => {
          return (
            <React.Fragment key={name}>
              <ListItem disableGutters className={classes.roleContainer}>
                <Typography className={classes.text} variant="subtitle1">
                  {name}
                </Typography>
                <Typography className={classes.text} variant="subtitle1">
                  {roles?.map(function RoleListItem(role: string, i): React.ReactElement {
                    return (
                      <React.Fragment key={`${name}-${role}`}>
                        {role}
                        {i < (roles?.length || 0) && <br />}
                      </React.Fragment>
                    );
                  })}
                </Typography>
              </ListItem>
              <Divider />
            </React.Fragment>
          );
        })}
      </List>
    </Paper>
  );
};

export default UserOrganizationRoleInformation;
